/*
 Leaving modal handlers
 */

var leavingModals = {
  leavingHandlers: function leavingHandlers() {
    var leavingButtons = document.querySelectorAll(".leavingHandler");
    var overflowBlock = document.querySelector(".veil");
    var closeButton = document.querySelector(".leavingModal__close");
    leavingButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        openLeavingModal(event);
      });
    });

    if (leavingButtons) {
      overflowBlock.addEventListener("click", function () {
        closeLeavingModal();
      });
    }

    if (closeButton) {
      closeButton.addEventListener("click", function () {
        closeLeavingModal();
      });
    }

    function openLeavingModal(event) {
      var leavingModalElement = document.querySelector(".leavingModal");
      var mobileNav = document.querySelector("#mobileNav");
      event.preventDefault();
      if (leavingModalElement) {
        leavingModalElement.classList.add("leavingModal--visible");
        document.body.classList.add("show-leaving-modal");
      }

      if (mobileNav) {
        mobileNav.classList.remove("show");
        document.body.classList.remove("js-menu-active");
      }
    }

    function closeLeavingModal() {
      var leavingModalElement = document.querySelector(".leavingModal");
      leavingModalElement.classList.remove("leavingModal--visible");
      document.body.classList.remove("show-leaving-modal");
    }
  }
};
